module.exports = new __parcel__URL__("72040_sq.78745dc1.jpg").toString();